export default "/images/image-bottom.jpg?6b70bafd6880e3365fa6a62652bf42a7";